import { handleActions, createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';
import { getDefaultChannelDataSources } from 'helpers/channels';
import { merge, get } from 'lodash';

// Actions
export const actions = mapActions([
    'CREATE_ENTITY',
    'CLEAR_ENTITY',
    'FETCH_LIST',
    'FETCH_LIST_SUCCESS',
    'FETCH_META',
    'FETCH_META_SOCIAL',
    'FETCH_META_SOCIAL_SUCCESS',
    'FETCH_META_SUCCESS',
    'FETCH_ENTITY',
    'FETCH_ENTITY_SUCCESS',
    'FETCH_ENTITY_CHILDREN',
    'FETCH_ENTITY_CHILDREN_SUCCESS',
    'FETCH_DATA_RANGE',
    'FETCH_DATA_RANGE_SUCCESS',
    'FETCH_HIERARCHY_DUMP',
    'FETCH_ENTITY_ATV_LAB_DATA',
    'REFRESH_ENTITY_ATV_LAB_DATA',
    'FETCH_ENTITY_ATV_LAB_DATA_SUCCESS',
    'UPDATE_ENTITY',
    'UPDATE_ENTITY_BRANDING',
    'UPDATE_ENTITY_ATV_LAB_CSV',
    'SET_META_CHANNEL_AVAILABILITY',
    'RESET_META_CHANNEL_AVAILABILITY',
    'DELETE_ENTITY',
    'DELETE_ENTITY_SUCCESS',
    'REQUEST_UPSELL_SUCCESS',
    'ADD_NEW_WORK_ORDER_TO_EDIT_FORM',
    'ADD_NEW_WORK_ORDER_TO_CREATE_FORM',
    'ADD_NEW_CUSTOM_CHANNEL_TO_EDIT_FORM',
    'ADD_NEW_CUSTOM_CHANNEL_TO_CREATE_FORM',
    'RESET_WORK_ORDER_TO_MATCH_BRAND_EDIT_FORM',
    'RESET_WORK_ORDER_TO_MATCH_BRAND_CREATE_FORM',
    'SWITCH_ALL_WORK_ORDER_PLATFORMS_CREATE_FORM',
    'SWITCH_ALL_WORK_ORDER_PLATFORMS_EDIT_FORM',
    'CLONE_EXISTING_WORK_ORDER_TO_EDIT_FORM',
    'CLONE_EXISTING_WORK_ORDER_TO_CREATE_FORM',
    'SET_META_SITE_DIRECT_CHANNELS',
    'REQUEST_OPPORTUNITY_ID_INFORMATION',
    'SET_OPPORTUNITY_ID_INFORMATION',
    'SEARCH_FOR_OPPORTUNITIES',
    'SEARCH_FOR_OPPORTUNITIES_SUCCESS',
    'CLEAR_SEARCH_FOR_OPPORTUNITIES'
], 'ENTITY');


// Action Creators
export const createEntityForm = createFormAction(actions.CREATE_ENTITY);
export const updateEntityForm = createFormAction(actions.UPDATE_ENTITY);
export const updateEntityBrandingForm = createFormAction(actions.UPDATE_ENTITY_BRANDING);
export const clearEntity = createAction(actions.CLEAR_ENTITY);
export const updateEntityATVLabCSV = createAction(actions.UPDATE_ENTITY_ATV_LAB_CSV);
export const fetchList = createAction(actions.FETCH_LIST);
export const fetchListSuccess = createAction(actions.FETCH_LIST_SUCCESS);
export const fetchEntityDataRange = createAction(actions.FETCH_DATA_RANGE);
export const fetchEntityDataRangeSuccess = createAction(actions.FETCH_DATA_RANGE_SUCCESS);
export const fetchMeta = createAction(actions.FETCH_META);
export const fetchMetaSocial = createAction(actions.FETCH_META_SOCIAL);
export const fetchMetaSocialSuccess = createAction(actions.FETCH_META_SOCIAL_SUCCESS, data => data);
export const fetchMetaSuccess = createAction(actions.FETCH_META_SUCCESS, data => data);
export const fetchEntity = createAction(actions.FETCH_ENTITY);
export const fetchEntitySuccess = createAction(actions.FETCH_ENTITY_SUCCESS);
export const fetchEntityChildren = createAction(actions.FETCH_ENTITY_CHILDREN);
export const fetchEntityChildrenSuccess = createAction(actions.FETCH_ENTITY_CHILDREN_SUCCESS);
export const fetchHierarchyDump = createAction(actions.FETCH_HIERARCHY_DUMP);
export const fetchEntityATVLabData = createAction(actions.FETCH_ENTITY_ATV_LAB_DATA);
export const refreshEntityATVLabData = createAction(actions.REFRESH_ENTITY_ATV_LAB_DATA);
export const fetchEntityATVLabDataSuccess = createAction(actions.FETCH_ENTITY_ATV_LAB_DATA_SUCCESS);
export const setMetaChannelAvailability = createAction(actions.SET_META_CHANNEL_AVAILABILITY);
export const resetMetaChannelAvailability = createAction(actions.RESET_META_CHANNEL_AVAILABILITY);
export const deleteEntity = createAction(actions.DELETE_ENTITY);
export const deleteEntitySuccess = createAction(actions.DELETE_ENTITY_SUCCESS);
export const requestUpsellSuccess = createAction(actions.REQUEST_UPSELL_SUCCESS);
export const addNewWorkOrderToEditForm = createAction(actions.ADD_NEW_WORK_ORDER_TO_EDIT_FORM);
export const addNewWorkOrderToCreateForm = createAction(actions.ADD_NEW_WORK_ORDER_TO_CREATE_FORM);
export const addNewCustomChannelToEditForm = createAction(actions.ADD_NEW_CUSTOM_CHANNEL_TO_EDIT_FORM);
export const addNewCustomChannelToCreateForm = createAction(actions.ADD_NEW_CUSTOM_CHANNEL_TO_CREATE_FORM);
export const resetWorkOrderToMatchBrandEdit = createAction(actions.RESET_WORK_ORDER_TO_MATCH_BRAND_EDIT_FORM);
export const resetWorkOrderToMatchBrandCreate = createAction(actions.RESET_WORK_ORDER_TO_MATCH_BRAND_CREATE_FORM);
export const cloneExistingWorkOrderToEditForm = createAction(actions.CLONE_EXISTING_WORK_ORDER_TO_EDIT_FORM);
export const cloneExistingWorkOrderToCreateForm = createAction(actions.CLONE_EXISTING_WORK_ORDER_TO_CREATE_FORM);
export const switchAllWorkOrderPlatformsCreate = createAction(actions.SWITCH_ALL_WORK_ORDER_PLATFORMS_CREATE_FORM);
export const switchAllWorkOrderPlatformsEdit = createAction(actions.SWITCH_ALL_WORK_ORDER_PLATFORMS_EDIT_FORM);
export const setMetaSiteDirectChannels = createAction(actions.SET_META_SITE_DIRECT_CHANNELS);
export const requestOpportunityIdInformation = createAction(actions.REQUEST_OPPORTUNITY_ID_INFORMATION, (inputs) => {
    if (Array.isArray(inputs)) {
        return inputs;
    }

    return [inputs];
});
export const setOpportunityIdInformation = createAction(actions.SET_OPPORTUNITY_ID_INFORMATION);
export const searchForOpportunities = createAction(actions.SEARCH_FOR_OPPORTUNITIES);
export const searchForOpportunitiesSuccess = createAction(actions.SEARCH_FOR_OPPORTUNITIES_SUCCESS);
export const clearSearchForOpportunities = createAction(actions.CLEAR_SEARCH_FOR_OPPORTUNITIES);


const channelAvailability = {
    display: true,
    mobile: true,
    native: true,
    video: true,
    sem: true,
    audio: true,
    social: true,
    tv: true,
    site: true,
    youtube: true,
};

// Reducers
const initialState = {
    list: [],
    listFetched: false,
    dataRange: {},
    meta: {
        id: null,
        channelAvailability,
        childAliasNames: {},
        firstOrderChildren: [],
        enabledChannels: [],
        enrollmentSite: null,
        upsellRequested: {},
        branding: {},
        siteDirect: {},
        social: {
            objectives: []
        },
    },
    opportunityIdInfo: {},
    entity: null
};

export default handleActions({
    [actions.FETCH_LIST_SUCCESS]: (state, action) => {
        const updatedData = {
            list: { $set: action.payload },
            listFetched: { $set: true }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_META_SUCCESS]: (state, action) => {
        const meta = Object.assign({
            channelAvailability: initialState.meta.channelAvailability,
            firstOrderChildren: initialState.meta.firstOrderChildren,
            enabledChannels: initialState.meta.enabledChannels,
            childAliasNames: initialState.meta.childAliasNames,
            enrollmentSite: initialState.meta.enrollmentSite,
            upsellRequested: {},
            branding: initialState.meta.branding,
            labs: initialState.meta.labs,
            social: initialState.meta.social,
            siteDirect: initialState.meta.siteDirect,
        }, action.payload);


        const updatedData = {
            meta: { $set: meta }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_META_SOCIAL_SUCCESS]: (state, action) => {
        const updatedData = {
            meta: {
                social: { $set: action.payload }
            }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_ENTITY_SUCCESS]: (state, action) => {
        // Set meta to undefined so the default channelDataSources will be picked up. (Null will override)
        if (action.payload && action.payload.meta === null) {
            action.payload.meta = undefined;
        }

        const entity = merge({}, {
            meta: {
                channelDataSources: getDefaultChannelDataSources(action.payload.entityPlatform)
            }
        }, action.payload);
        const updatedData = {
            entity: {
                $set: entity
            }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_ENTITY_CHILDREN_SUCCESS]: (state, action) => {
        const updatedData = {
            entity: {
                $merge: {
                    children: action.payload
                }
            }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_ENTITY_ATV_LAB_DATA_SUCCESS]: (state, action) => {
        const updatedData = {
            meta: {
                meta: {
                    $merge: {
                        labs: {
                            crossChannelData: action.payload
                        }
                    }
                }
            }
        };
        return update(state, updatedData);
    },
    [actions.REFRESH_ENTITY_ATV_LAB_DATA]: (state) => {
        const updatedData = {
            meta: {
                meta: {
                    $merge: {
                        labs: {
                            crossChannelData: {
                                refresh: true
                            }
                        }
                    }
                }
            }
        };
        return update(state, updatedData);
    },
    [actions.SET_META_CHANNEL_AVAILABILITY]: (state, action) => {
        const availability = Object.assign({}, state.meta.channelAvailability);
        Object.keys(action.payload).forEach((key) => {
            if (availability[key] !== undefined && availability[key]) {
                availability[key] = action.payload[key];
            }
        });

        const updatedData = {
            meta: { channelAvailability: { $set: availability } }
        };

        return update(state, updatedData);
    },
    [actions.RESET_META_CHANNEL_AVAILABILITY]: (state) => {
        const updatedData = { meta: { channelAvailability: { $set: channelAvailability } } };
        return update(state, updatedData);
    },
    [actions.DELETE_ENTITY_SUCCESS]: (state) => {
        const updatedData = {
            entity: { $set: null }
        };
        return update(state, updatedData);
    },
    [actions.REQUEST_UPSELL_SUCCESS]: (state, action) => {
        const updatedData = {
            meta: {
                upsellRequested: {
                    [action.payload.channel]: { $set: true }
                }
            }
        };
        return update(state, updatedData);
    },
    [actions.SET_META_SITE_DIRECT_CHANNELS]: (state, action) => {
        const updatedData = {
            meta: {
                siteDirect: {
                    $merge: {
                        channels: action.payload
                    }
                }
            }
        };
        return update(state, updatedData);
    },
    [actions.CLEAR_ENTITY]: (state) => {
        const updatedData = {
            entity: {
                $set: {}
            }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_DATA_RANGE_SUCCESS]: (state, action) => update(state, { dataRange: { $set: get(action.payload, 'data', {}) } }),
    [actions.SEARCH_FOR_OPPORTUNITIES]: (state, action) => update(state, {
        searchForOpportunitiesSearchInput: { $set: get(action.payload, 'searchInput', '') },
        searchForOpportunitiesIsWaiting: { $set: true }
    }),
    [actions.CLEAR_SEARCH_FOR_OPPORTUNITIES]: state => update(state, {
        searchForOpportunitiesResults: { $set: [] },
        searchForOpportunitiesIsWaiting: { $set: false },
        searchForOpportunitiesSearchInput: { $set: '' }
    }),
    [actions.SEARCH_FOR_OPPORTUNITIES_SUCCESS]: (state, action) => update(state, {
        searchForOpportunitiesResults: { $set: get(action.payload, 'data.salesforceOpportunities', []) },
        searchForOpportunitiesIsWaiting: { $set: false }
    }),
    [actions.SET_OPPORTUNITY_ID_INFORMATION]: (state, action) => update(state, {
        opportunityIdInfo: {
            $merge: {
                [action.payload.opportunityId]: action.payload
            }
        }
    })
}, initialState);



// WEBPACK FOOTER //
// ./src/services/entities/duck.js